export default "__VITE_ASSET__uhQdR8l7__"